// Libraries
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Field, initialize, reduxForm } from 'redux-form';
import { Form } from 'semantic-ui-react';

// Components
import CustomButton from '../../../../components/form/button';
import CustomInput from '../../../../components/form/input';

// Redux
import { closeLoader, openLoader } from '../../../../../redux-store/loader';

// Models
import SecurityModel from '../../../../../data/models/security/security';

// Locales
import I18n from '../../../../../i18n';

class ConfigForm extends React.Component {

    componentDidMount() {
        this.getConfigData();
    }

    getConfigData = async () => {

        const { dispatch } = this.props;

        try {

            this.props.openLoader();

            const response = await SecurityModel.getDirectoryConfig();

            const refundPercent = String(response?.data?.refundPercent || 10);
            const ratingPeriod = String(response?.data?.ratingPeriod || 30);

            dispatch(initialize(
                'directoryConfigForm',
                {
                    refundPercent,
                    ratingPeriod
                }
            ));

        } catch (error) {

            console.error(error);

        } finally {

            this.props.closeLoader();

        }

    };

    onSubmit = async (values) => {

        try {

            this.props.openLoader();

            values.refundPercent = parseInt(values.refundPercent);
            values.ratingPeriod = parseInt(values.ratingPeriod);

            await SecurityModel.updatedDirectoryConfig(values);

        } catch (error) {

            console.error(error);

        } finally {

            this.props.closeLoader();

        }

    }

    render() {

        return (

            <Form name="directoryConfigForm" onSubmit={this.props.handleSubmit(this.onSubmit)} noValidate>
                <div>
                    <div className='verticalPad'>
                        <h2>{I18n.t('pro.directory.config.cancellations')}</h2>
                        <Field
                            component={ CustomInput }
                            name="refundPercent"
                            type="number"
                            min={0}
                            label={ I18n.t('pro.directory.config.refundPercent') } 
                        />
                    </div>
                    <div className='verticalPad'>
                        <h2>{I18n.t('pro.directory.config.ratings')}</h2>
                        <Field
                            component={ CustomInput }
                            name="ratingPeriod"
                            type="number"
                            min={0}
                            label={ I18n.t('pro.directory.config.ratingPeriod') } 
                        />
                        <p>{I18n.t('pro.directory.config.ratingPeriodDescription')}</p>
                    </div>
                </div>
                <div className="verticalPad">
                    <CustomButton type="submit" text={ I18n.t('pro.directory.save') } ></CustomButton>
                </div>
            </Form>

        );

    }

}

const validate = formValues => {

    const errors = {};

    if (_.isEmpty(formValues.refundPercent)) {

        errors.refundPercent = I18n.t('validations.required');

    }

    const refundPercent = Number(formValues.refundPercent);

    if (refundPercent < 0) {

        errors.refundPercent = I18n.t('validations.required');

    }

    return errors;

};

export default reduxForm({
    form: 'directoryConfigForm',
    touchOnBlur: true,
    touchOnChange: false,
    validate,
})(connect(null, { closeLoader, openLoader })(ConfigForm));